<template>
  <div class="selected-locations-display bg-blue-50 p-3 rounded-md border border-blue-200 flex items-center justify-between shadow-sm">
    <div class="flex items-center">
      <v-icon color="blue darken-2" class="mr-2">mdi-filter-variant</v-icon>
      <span class="text-sm text-blue-700">
        Showing <strong class="font-semibold">{{ selectedCount }}</strong> of <strong class="font-semibold">{{ totalCount }}</strong> locations based on your filters.
      </span>
    </div>
    <v-btn
      small
      outlined
      color="blue darken-2"
      @click="$emit('clear-filters')"
      class="ml-4 text-xs"
    >
      <v-icon left small>mdi-filter-remove-outline</v-icon>
      Clear Filters
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'SelectedLocationsDisplay',
  props: {
    selectedCount: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.selected-locations-display {
  /* Add any specific styles if needed */
}
</style> 